export default function applySequentialDiscounts(total, promotions) {
  let discountedPrice = total;
  let discountSequences = [];

  for (let i = 0; i < promotions?.length; i++) {
    const discountPercentage = promotions[i]?.discount;

    const discountAmount = (discountedPrice * discountPercentage) / 100;
    discountSequences.push({
      promotion: promotions[i],
      discountAmount,
      originalPrice: discountedPrice,
      discountedPrice: discountedPrice - discountAmount,
    });
    discountedPrice -= discountAmount;
  }

  return { finalPrice: discountedPrice, discountSequences };
}
